import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import apiClient from '../services/apiClient';
import { useAuth } from './AuthContext';

const OrgContext = createContext(null);

export function OrgProvider({ children }) {
  const [currentOrg, setCurrentOrg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { user, loading: authLoading } = useAuth();

  const refresh = useCallback(async () => {
    if (!user?.id) {
      setCurrentOrg(null);
      setIsLoading(false);
      return;
    }
    try {
      // userRoutes se monta en /api/users (server.js), así que la ruta real es
      // /api/users/me/org — igual que /api/users/me/profile. Llamar a /api/me/org
      // caía al fallback SPA (HTML) → currentOrg=null → owners de org no veían
      // Analytics ni el resto de features gateadas por member_role (#114).
      const org = await apiClient.get('/api/users/me/org');
      setCurrentOrg(org || null);
    } catch (error) {
      console.error('[OrgContext] Failed to load org:', error);
      setCurrentOrg(null);
    } finally {
      setIsLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    if (authLoading) return;
    setIsLoading(true);
    refresh();
  }, [user?.id, authLoading, refresh]);

  return (
    <OrgContext.Provider value={{ currentOrg, isLoading, refresh }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error('useOrg must be used inside OrgProvider');
  return ctx;
}

export default OrgContext;
